/**
 * ドライバースケジュール
 * 受注の紐付けをすべて解除
 */
import Vue from 'vue'
import * as httpConst from '../../../../constants/httpConst'

const driver_schedule_bulk_deletion = {
  namespaced: true,
  state: {},
  getters: {},
  actions: {
    /**
     * 受注の紐付けをすべて解除
     * @param commit
     * @param driver_schedule_id
     * @returns {Promise<unknown>}
     */
    destroy ({ commit }, { driver_schedule_id }) {
      return new Promise((resolve) => {
        Vue.$http.delete(`${httpConst.DRIVER_ENDPOINT}/driver_schedules/${driver_schedule_id}/bulk_deletions`).then(data => {
          commit('snackbar/showInfo', { message: '解除しました' }, { root: true })
          resolve(data.content)
        })
      })
    },
  },
}

export default driver_schedule_bulk_deletion
